import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Inicio from './components/Inicio';
import Nosotros from './components/Nosotros';
import Servicios from './components/Servicios';
import Soluciones from './components/Soluciones';
import CasosDeExito from './components/CasosDeExito';
import Blog from './components/Blog';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import BotonScroll from './components/BotonScroll';
import PoliticaDeCookies from './components/PoliticaDeCookies';
import PoliticaDePrivacidad from './components/PoliticaDePrivacidad';
import CookieModal from './components/CookieModal';
import Josemite from './components/servicios/Josemite'; 
import AplicacionPlantaFabricacion from './components/servicios/AplicacionPlantaFabricacion';
import GestionControlHorario from './components/servicios/GestionControlHorario';
import GestionDePartes from './components/servicios/GestionDePartes';
import GestorPedidosCompra from './components/servicios/GestorPedidosCompra';
import ImputacionDeProyectos from './components/servicios/ImputacionDeProyectos';
import SGA from './components/servicios/SGA';

import ValidadorDePagos from './components/servicios/ValidadorDePagos';
import ValidadorDePedidos from './components/servicios/ValidadorDePedidos';
import Ticket from './components/Ticket'; 
import BotonFlotante from './components/BotonFlotante'; 
import Formulario from './components/Formulario'; 
import EntregasCuenta from './components/servicios/EntregasCuenta'; 
import GestorDeTalleres from './components/servicios/GestorDeTalleres'; 
import GestorDeTransporte from './components/servicios/GestorDeTransporte'; 
import './App.css';

function App() {
  return (
    <Router>
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/soluciones" element={<Soluciones />} />
          <Route path="/casos-de-exito" element={<CasosDeExito />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/politica-de-cookies" element={<PoliticaDeCookies />} />
          <Route path="/politica-de-privacidad" element={<PoliticaDePrivacidad />} />
          <Route path="/josemite-control-de-proyectos-y-tareas" element={<Josemite />} />
          <Route path="/aplicacion-planta-fabricacion" element={<AplicacionPlantaFabricacion />} />
          <Route path="/gestion-control-horario" element={<GestionControlHorario />} />
          <Route path="/gestion-de-partes" element={<GestionDePartes />} />
          <Route path="/gestor-pedidos-compra" element={<GestorPedidosCompra />} />
          <Route path="/imputacion-de-proyectos" element={<ImputacionDeProyectos />} />
          <Route path="/sga-gestion-de-almacen" element={<SGA />} />
          <Route path="/validador-de-pagos" element={<ValidadorDePagos />} />
          <Route path="/validador-de-pedidos" element={<ValidadorDePedidos />} />
          <Route path="/tickets" element={<Ticket />} />
          <Route path="/entregas-cuenta-proveedores" element={<EntregasCuenta />} />
          <Route path="/gestor-talleres" element={<GestorDeTalleres />} />
          <Route path="/gestor-transporte" element={<GestorDeTransporte />} />
          <Route path="/formulario" element={<Formulario />} />
        </Routes>
      </div>
      <Footer />
      <BotonScroll />
      <CookieModal />
      <BotonFlotante />
    </Router>
  );
}

export default App;
